import React from "react";
import LegalLink from "./LegalLink";
import { CONSENT_PATH, OPERATOR } from "./operator";

/**
 * Галочка согласия на обработку ПД; оформление задаёт форма через классы.
 * coveredByAccount — заказ на почту кабинета: вместо галочки строка, что согласие уже дано.
 */
function PersonalDataConsent({
  checked,
  onChange,
  disabled = false,
  coveredByAccount = false,
  className = "",
  inputClassName = "",
  textClassName = "",
  linkClassName = "",
}) {
  const link = (
    <LegalLink
      href={CONSENT_PATH}
      tip={`Оператор ПД — ${OPERATOR.shortName}`}
      className={linkClassName}
    >
      обработку персональных данных
    </LegalLink>
  );

  if (coveredByAccount) {
    return (
      <p className={`${className} legal-consent-covered`}>
        <span className={textClassName}>
          Согласие на {link} вы дали при создании кабинета
        </span>
      </p>
    );
  }

  return (
    <label className={className}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        className={inputClassName}
      />
      <span className={textClassName}>Я даю согласие на {link}</span>
    </label>
  );
}

export default PersonalDataConsent;
